import { Component, OnInit, Input, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorType } from 'src/app/enums/error-type.enum';
import {FormGroup, FormControl} from '@angular/forms';
import * as moment from 'moment';
import { CommonService } from 'src/app/services/common.service';
import { EventService } from 'src/app/services/event.service';
import { UserData } from 'src/app/models/user-data.models';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { PusherService } from 'src/app/services/pusher.service';
import {SelectionModel} from '@angular/cdk/collections';
import { MergeLeadModalComponent } from '../merge-lead-modal/merge-lead-modal.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface hour {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'fury-lead-list',
  templateUrl: './lead-list.component.html',
  styleUrls: ['./lead-list.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class LeadListComponent implements OnInit, OnDestroy {
  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  @Input()
  columns = [
    { name: 'Select', property: 'select', visible: true, isModelProperty: true },
    {name: 'Added On', property: 'addedOn', visible: true},
    {name: 'Source', property: 'source', visible: true},
    {name: 'Total Cost', property: 'soldAmount', visible: true},
    {name: 'Result Code', property: 'resultCode', visible: true},
    {name: 'First Name', property: 'firstName', visible: true},
    {name: 'Last Name', property: 'lastName', visible: true},
    {name: 'Verified Name', property: 'verifiedName', visible: true},
    {name: 'Email', property: 'emailAddress', visible: true},
    {name: 'Mobile No', property: 'mobileNumber', visible: true},
    {name: 'Address', property: 'address', visible: true},
    {name: 'City', property: 'city', visible: true},
    {name: 'State', property: 'state', visible: true},
    {name: 'Zip Code', property: 'zipCode', visible: true},
    {name: 'Attempts', property: 'attempts', visible: true},
    {name: 'Status', property: 'vanillaSoftStatus', visible: true},
    {name: 'Last Agent Name', property: 'lastAgentName', visible: true},
    {name: 'Submission', property: 'submission', visible: true},
    {name: 'Last Date', property: 'vanillaSoftTimestamps', visible: true},
    {name: 'Lead Status', property: 'leadStatus', visible: true},
    {name: '3rd Party Status', property: 'thirdPartyStatus', visible: true},
    { name: 'Actions', property: 'actions', visible: true },
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  itemList: any;
  filterValue: any;
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;
  notPostedLeadCount: any;
  tabName: string = 'totalLeads';
  today = new Date();
  month = this.today.getMonth();
  year = this.today.getFullYear();
  startDate:any;
  endDate: any;
  dashboardDetails:any;
  leadSearchForm = new FormGroup({
    source: new FormControl(""),
    firstName: new FormControl(""),
    lastName: new FormControl(""),
    verifiedName: new FormControl(""),
    emailAddress: new FormControl(""),
    mobileNumber: new FormControl(""),
    address: new FormControl(""),
    city: new FormControl(""),
    state: new FormControl(""),
    zip: new FormControl(""),
    attempts: new FormControl(""),
    resultCode: new FormControl(""),
    status: new FormControl(""),
    lastAgentName: new FormControl(""),
  });

   campaignOne = new FormGroup({
     start: new FormControl<Date | null>(null),
     end: new FormControl<Date | null>(null),
   });
   campaignTwo = new FormGroup({
     start: new FormControl(new Date(this.year, this.month, 15)),
     end: new FormControl(new Date(this.year, this.month, 19)),
   });
   selectType = new FormGroup({
     type: new FormControl<string | null>('hourType'),
     hourValue: new FormControl(null),
   })
  isAdmin !: boolean;
  isActive : boolean = false;
  private channel: any; 
  selection = new SelectionModel(true, []);
  ngUnsubscribe = new Subject<void>();
  
  constructor(
    private apiservice: ApiService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public commonService: CommonService,
    private eventService: EventService,
    private pusherService: PusherService
  ) {
    const tomorrow = moment(this.today).add(1, "days").format('YYYY-MM-DD');    
    this.endDate = moment(tomorrow).subtract(1, "seconds").format('YYYY-MM-DD HH:mm:ss');
    this.startDate = moment(moment().format("YYYY-MM-DD")).subtract(30, "days").format("YYYY-MM-DD HH:mm:ss");
    this.filterValue = 'Incoming Leads';
    this.router.onSameUrlNavigation = 'reload';

    this.activatedRoute.queryParams.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
      this.pageIndex = res.page ? res.page - 1 : 0;
      this.pageSize = res.size ? (res.size === 'all' ? 9999 : res.size) : 30;
      this.tabName = res?.tabName ? res.tabName : 'totalLeads';
      this.getLeadRequestList();
    });
    eventService.userData.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: UserData) => {
      this.isAdmin = res.isAdmin;
      if(!this.isAdmin){
        this.columns = [
          { name: 'Select', property: 'select', visible: true, isModelProperty: true },
          {name: 'Added On', property: 'addedOn', visible: true},
          {name: 'Source', property: 'source', visible: true},
          {name: 'Total Cost', property: 'soldAmount', visible: true},
          {name: 'Result Code', property: 'resultCode', visible: true},
          {name: 'First Name', property: 'firstName', visible: true},
          {name: 'Last Name', property: 'lastName', visible: true},
          {name: 'Verified Name', property: 'verifiedName', visible: true},
          {name: 'Email', property: 'emailAddress', visible: true},
          {name: 'Mobile No', property: 'mobileNumber', visible: true},
          {name: 'Address', property: 'address', visible: true},
          {name: 'City', property: 'city', visible: true},
          {name: 'State', property: 'state', visible: true},
          {name: 'Zip Code', property: 'zipCode', visible: true},
          {name: 'Attempts', property: 'attempts', visible: true},
          {name: 'Status', property: 'vanillaSoftStatus', visible: true},
          {name: 'Last Agent Name', property: 'lastAgentName', visible: true},
          {name: 'Submission', property: 'submission', visible: true},
          {name: 'Last Date', property: 'vanillaSoftTimestamps', visible: true},
          {name: 'Lead Status', property: 'leadStatus', visible: true},
          { name: 'Actions', property: 'actions', visible: true },
        ];
      }
    });
  }
  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }
  ngOnInit(): void {
    this.getDashboardData();
    this.getPusherData();
  }


  pageSizeChange(event: any) {    
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(
      `/lead/lead-list?page=${this.pageIndex + 1
      }${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&tabName=${this.tabName}`
    );
  }
  getLeadRequestList() {
    const {source,firstName,lastName,verifiedName, emailAddress, mobileNumber, address, city, state,zip, attempts, resultCode, status, lastAgentName } = this.leadSearchForm.value;

    const queryParams =`?page=${Number(this.pageIndex) + 1}&size=${this.pageSize}&source=${source}&firstName=${firstName}&lastName=${lastName}&verifiedName=${verifiedName}&emailAddress=${emailAddress}&mobileNumber=${mobileNumber}&address=${address}&city=${city}&state=${state}&zip=${zip}&attempts=${attempts}&resultCode=${resultCode}&status=${status}&lastAgentName=${lastAgentName}&tabName=${this.tabName}&startDate=${this.startDate}&endDate=${this.endDate}&isActive=${this.isActive ? 1 : 0}`;
    this.apiservice
      .get(
        `admin/lead/get-all-leads${queryParams}`
      )
      .pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
        if (res.body) {
          this.notPostedLeadCount = res.body?.notPostedLeadCount;
          if (res.body.leads.data) {
            this.itemList = res.body.leads.data;
            this.totalCount = res.body.leads.total;
            this.dataSource = new MatTableDataSource(this.itemList);
            // this.selection = new SelectionModel(true, []);
            this.cdr.detectChanges();
          } else {
            this.itemList = undefined;
          }
        }
      });
  }

  navigateDetailsPage(data:any){
    this.router.navigateByUrl('/lead/lead-details/'+ data.leadId + '?type=customerInformation');
  }
  postUnPostedLead(){
    this.apiservice.patch('admin/lead/post-all-un-posted-leads-to-vanilla-soft').pipe(takeUntil(this.ngUnsubscribe)).subscribe((res:any)=>{
      if(res?.body){
        this.getLeadRequestList();
        this.apiservice.alert(res?.body?.message, 'success');
      }
    }, err =>{
      this.apiservice.alert('Please try again', 'error');
    })
  }
  reportBadLead(row: any){
    this.apiservice.patch(`admin/lead/report-as-bad-lead/${row?.leadId}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any)=>{
      if(res){
        this.apiservice.alert(res?.body?.message, ErrorType.Success);
        this.getLeadRequestList();
      }
    }, err =>{
      if(err){
        this.apiservice.alert(err?.message, ErrorType.Error);
      }
    })
  }
  reportGoodLead(row: any){
    this.apiservice.patch(`admin/lead/report-as-good-lead/${row?.leadId}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any)=>{   
      if(res){
        this.apiservice.alert(res?.body?.message, ErrorType.Success);
        this.getLeadRequestList();
      }
    }, err =>{
      if(err){
        this.apiservice.alert(err?.message, ErrorType.Error);
      }
    })
  }
  changeTabName(tabName: string){
    if(this.isAdmin){
      this.tabName = tabName;
      this.router.navigateByUrl(
      `/lead/lead-list?page=${this.pageIndex + 1
      }${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&tabName=${this.tabName}`
    );
    }
  };
  // lead Dashboard

   hours: hour[] = [
     {value: '4hrs', viewValue: '4hrs'},
     {value: '12hrs', viewValue: '12hrs'},
     {value: '24hrs', viewValue: '24hrs'},
     {value: '48hrs', viewValue: '48hrs'},
     {value: '72hrs', viewValue: '72hrs'},
     {value: '7days', viewValue: '7days'},
     {value: '14days', viewValue: '14days'},
     {value: '30days', viewValue: '30days'}
   ];

   getDashboardData(){
    this.apiservice.get(`admin/dashboard/get-dashboard-data?startDate=${this.startDate}&endDate=${this.endDate}&isActive=${this.isActive ? 1 : 0}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res:any)=>{
     if(res?.body){
      this.dashboardDetails = res?.body;
     }
    }, err =>{
      this.apiservice.alert('Something went wrong', 'error');
    })
  };
  dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement){
    this.selectType.patchValue({
      hourValue: null
    })
    this.startDate = moment(this.campaignOne.value.start).format('YYYY-MM-DD HH:mm:ss');
    this.endDate = moment(this.campaignOne.value.end).format('YYYY-MM-DD HH:mm:ss');
    this.getDashboardData();
    this.getLeadRequestList();
  };
  hourRangeChange(e:any){
    this.campaignOne.patchValue({
      start: null,
      end: null
    })
    if(e.value === '4hrs'){
      this.startDate = moment().subtract(4, "hour").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    } else if(e.value === '12hrs'){
      this.startDate = moment().subtract(12, "hour").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    } else if(e.value === '24hrs'){
      this.startDate = moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    } else if(e.value === '48hrs'){
      this.startDate = moment().subtract(2, "days").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    } else if(e.value === '72hrs'){
      this.startDate = moment().subtract(3, "days").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    } else if(e.value === '7days'){
      this.startDate = moment().subtract(7, "days").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    } else if(e.value === '14days'){
      this.startDate = moment().subtract(14, "days").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    } else if(e.value === '30days'){
      this.startDate = moment().subtract(30, "days").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    }
    this.getDashboardData();
    this.getLeadRequestList();
  }

  changeStatus(event: MatSlideToggleChange){
    this.isActive = event.checked;
    this.getDashboardData();
    this.getLeadRequestList();
  };
  reportFlagLead(row: any){
    this.apiservice.patch(`admin/lead/report-as-flag-lead/${row?.leadId}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any)=>{
      if(res){
        this.apiservice.alert(res?.body?.message, ErrorType.Success);
        this.getLeadRequestList();
      }
      
    }, err =>{
      if(err){
        this.apiservice.alert(err?.message, ErrorType.Error);
      }
    })
  };
  removeFlagLead(row : any){
    this.apiservice.patch(`admin/lead/remove-lead-flag/${row?.leadId}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any)=>{
      if(res){
        this.apiservice.alert(res?.body?.message, ErrorType.Success);
        this.getLeadRequestList();
      }
      
    }, err =>{
      if(err){
        this.apiservice.alert(err?.message, ErrorType.Error);
      }
    })
  }
  removeAllFlagLead(row : any){
    this.apiservice.patch(`admin/lead/remove-lead-flag/${row?.leadId}/true`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any)=>{
      if(res){
        this.apiservice.alert(res?.body?.message, ErrorType.Success);
        this.getLeadRequestList();
      }
      
    }, err =>{
      if(err){
        this.apiservice.alert(err?.message, ErrorType.Error);
      }
    })
  }

  checkLead(data: string): boolean{
   const find = ["REP", "DUP", "DUPP", "DUPPP", "RH", "000",];
   return find.some(condition => data.includes(condition));
  };

  getPusherData(){
    this.channel = this.pusherService.getUpdateLeadList('new-lead');
    this.channel.bind('new-lead-updated', (data: any) => {
      this.getLeadRequestList();
      this.getDashboardData();
    });
  };

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  };

  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  };
  openMergeAccountModal(){
    if(this.selection.selected.length){
      const obj = { width: '400px', disableClose: true, data: this.selection.selected.map((item: any)=> item?.leadId)}
      const dialogRef = this.dialog.open(MergeLeadModalComponent, obj);
      dialogRef.afterClosed().pipe(takeUntil(this.ngUnsubscribe)).subscribe(result => {
        if (result) {
          this.getLeadRequestList();
          this.selection.clear();
        }
      });
    } else {
      this.apiservice.alert('Please select leads', ErrorType.Error);
    }
   
  }
  ngOnDestroy() { 
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
